import axios from "axios";
import { navigate } from "./navigation";
export const axiosInstance = axios.create({
    baseURL: process.env.REACT_APP_API_URL,
})
//Antes de enviar la respuesta de la petición verifica que tipo de contenido es

axiosInstance.interceptors.response.use( function (res) {
    if (res.headers["content-type"] === "text/html;charset=UTF-8"){
        sessionStorage.setItem("content", JSON.stringify(true));
        return res;
    } else {
        sessionStorage.setItem("content", JSON.stringify(false));
        return res;
    }
}, function (error){
        if ( error.response.status === 401  || error.response.status === 419 ){
            return  navigate("/");
        } else {
            return Promise.reject(error);
        }
    }
);
